export default {
    "version": "V0-1-082",
    "firebase": {
        "apiKey": "AIzaSyD28ks4jycV3Y8m4gmIhgnhkdHpFHISiZI",
        "authDomain": "dscom-bret-fb.firebaseapp.com",
        "databaseURL": "https://dscom-bret-fb.firebaseio.com",
        "projectId": "dscom-bret-fb",
        "storageBucket": "dscom-bret-fb.appspot.com",
        "messagingSenderId": "1062332039011"
    },
    "login":{
        "test_user": "",
        "test_pswd": "",
    }
}


// WEBPACK FOOTER //
// ./src/config.js